import MemberInvoiceNavSummary from '../../pages/ChamberMemberAdmin/Invoices/MemberInvoiceNavSummary';
import CmpMemberSidebar, { getSignedInContactName } from './CmpMemberSidebar';
import CmpMemberTestMode from './CmpMemberTestMode';
import useMemberDashboardAccess from '../Hooks/useMemberDashboardAccess';
import { canUseMemberRoute } from '../../pages/ChamberMemberAdmin/Invoices/memberInvoiceAccess';
import React, { useCallback, useContext, useMemo } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowUp from "@material-ui/icons/KeyboardArrowUp";
import ArrowDown from "@material-ui/icons/KeyboardArrowDown";
import PersonAddOutlinedIcon from "@material-ui/icons/PersonAddOutlined";
import CardGiftcardOutlinedIcon from "@material-ui/icons/CardGiftcardOutlined";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ListAltOutlinedIcon from "@material-ui/icons/ListAltOutlined";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import Toolbar from "@material-ui/core/Toolbar";
import { UserTypeContext } from "../../../UserTypeContext";
import {
  makeStyles,
  useTheme,
  Theme,
  createStyles,
} from "@material-ui/core/styles";
import clsx from "clsx";
import defaultEnumStrings, {
  RedirectUri,
  useEnumStrings,
} from "../../enumStrings";
import {
  ShopLocalCampaignStatusEnum,
  useGetActiveShopLocalCampaignForChamberMemberQuery,
  useGetAllShopLocalCampaignsForChamberQuery,
  useGetAllRewardCampaignsForChamberQuery,
  UserType,
  useGetSubscriptionPlanTypeQuery,
} from "../../../graphql/types";
import { Link, useLocation } from "react-router-dom";
import themes from "../../../themes";
import LogoImage from "../utilities/LogoImage";
import useGetChamberFromUserIdInAuth from "../Hooks/useGetChamberFromUserIdInAuth";
import CPALogo from "../../../images/Gold_Logo.png";
import useGetChamberMemberFromUserIdInAuth from "../Hooks/useGetChamberMemberFromUserIdInAuth";

import LanguageIcon from "../../../images/nav-icons/language.png";
import HelpIcon from "../../../images/nav-icons/help.png";
import LogoutIcon from "../../../images/nav-icons/logout.png";
import ManageCompanyProfileIcon from "../../../images/nav-icons/membermanagecompanyprofile.png";
import ManageAdvertMemberIcon from "../../../images/nav-icons/manageadvertmember.png";
import MemberCreatePerksIcon from "../../../images/nav-icons/membercreateperks.png";
import ManageCompanyPerksMemberIcon from "../../../images/nav-icons/managecompanyperksmember.png";

// Perks nav icons
import PerksNavIcon from "../../../images/nav-icons/perksnav.png";
import CreateMemberPerksNavIcon from "../../../images/nav-icons/creatememberperks.png";
import ManageMemberPerksNavIcon from "../../../images/nav-icons/manageperks.png";
import CreateMembersBlackIcon from "../../../images/nav-icons-update/create-members-black.png";

import CPAMarketingToolkitLogo from "../../../images/CPAMarketingToolkitLogo.png";
import HandWithPersonIconLogo from "../../../images/HandWithPersonIconLogo.png";

import useIsChamber from "../Hooks/useIsChamber";
import { useHandleLogout } from "../Hooks/useHandleLogout";
import { Chip, Tooltip, Typography } from "@material-ui/core";
import CustomChamberEngageIcon from "../../../images/CustomChamberEngageIcon.png";
import CustomChamberMarketerLogo from "../../../images/Learning Launchpad.png";
import CustomManualLaunchGuideLogo from "../../../images/CustomManualLaunchGuideLogo.png";
import useIsMemberProfileAndPerksBannersActiveForChamberMember from "../Hooks/useCheckIfMemberProfileAndPerksBannersActiveForChamberMember";
import ChamberEngageManageCategoryAdvertisingBannersChamberMemberIcon from "../../../images/ChamberEngageManageCategoryAdvertisingBannersChamberMemberIcon.png";
import { checkIfRewardCampaignIsActive } from "../utilities/rewardCampaign";
import useCheckIfCategoryAdvertisingBannersActiveForChamberMember from "../Hooks/useCheckIfCategoryAdvertisingBannersActiveForChamberMember.ts";
import ManageFeaturedMemberBannersIcon from "../../../images/sidebar-manage-banners.png";
import CredentialsIcon from "../../../images/nav-icons/credentials.png";
import MembersNavIcon from "../../../images/nav-icons/membersmanage.png";
import ManageMembersNavIcon from "../../../images/nav-icons/members.png";
import ViewStatsNavIcon from "../../../images/nav-icons/viewstats.png";
import ManageYourChamberNavIcon from "../../../images/nav-icons/manage_your_chamber.png";
import ShopLocalNavIcon from "../../../images/nav-icons/shop_local.png";
import RewardsNavIcon from "../../../images/nav-icons/rewards.png";
import PerkLinksNavIcon from "../../../images/nav-icons/perklinks.png";
import PerkPartnersPortalNavIcon from "../../../images/nav-icons-update/perklinks.png";
import PerkPartnersPortalOrangeNavIcon from "../../../images/nav-icons-update/perklink-orange.png";
import ChamberEngageNavIcon from "../../../images/nav-icons/chamberengage.png";
import FeaturedMemberNavIcon from "../../../images/nav-icons/featuredmemberstatus.png";
import CategoryAdvertNavIcon from "../../../images/nav-icons/categoryadvert.png";
import NewBadge, { BadgeType } from "../NewBadge";
import ComingSoonDialog from "../ComingSoonDialog";
import { getExternalLinkUrl } from "../utilities/externalLinkUrl";

const drawerWidth = 310;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: themes.palette.navbar.background,
      color: themes.palette.navbar.text,
      toolbar: themes.mixins.toolbar,
    },
    rootItem: {
      background: themes.palette.navbar.background,
      display: "flex",
    },

    drawer: {
      [theme.breakpoints.up("lg")]: {
        width: drawerWidth,
        flexShrink: 0,
      },
    },
    appBar: {
      [theme.breakpoints.up("lg")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        position: "relative",
        zIndex: theme.zIndex.drawer + 1,
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("lg")]: {
        display: "none",
      },
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
      width: drawerWidth,
      backgroundColor: themes.palette.navbar.background,
      overflowX: "hidden",
    },
    // Claude Design CMP member sidebar: 288px (CPA-only and staff keep drawerWidth).
    cmpDrawer: {
      [theme.breakpoints.up("lg")]: {
        width: 288,
        flexShrink: 0,
      },
    },
    cmpDrawerPaper: {
      width: 288,
      backgroundColor: themes.palette.navbar.background,
      overflowX: "hidden",
    },
    // Design sidebar (CMP Accelerator.dc.html <aside>): stays in place while the page
    // scrolls, at most 902px high, with its own thin scroll bar.
    cmpDrawerPaperDocked: {
      width: 288,
      backgroundColor: themes.palette.navbar.background,
      overflowX: "hidden",
      height: "100vh",
      maxHeight: 902,
      overflowY: "scroll",
      scrollbarWidth: "thin",
      scrollbarColor: "#C4C4C8 #F2F2F3",
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    hide: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
      display: "none",
    },
    largerProfileCircle: {
      width: "175px",
      height: "175px",
      background: "#F5F5F5",
      margin: "auto",
      marginTop: "18px",
      marginBottom: "38px",
      borderRadius: "100%",
    },
    profileIcon: {
      width: "calc(100% - 65px)",
      height: "120px",
      background: "white",
      margin: "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "5px",
    },
    adminTitle: {
      color: themes.palette.navbar.text,
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "150%",
      padding: "8px 16px 0",
      textAlign: "center",
      letterSpacing: "0.5px",
      overflowWrap: "anywhere",
    },
    listItemText: {
      color: themes.palette.navbar.text,
      marginTop: 0,
      marginBottom: 0,
      "& .MuiListItemText-primary, & span": {
        fontSize: "14px !important",
        fontWeight: "400 !important" as any,
        lineHeight: "150% !important",
        whiteSpace: "normal",
        overflowWrap: "anywhere",
      },
      MuiSvgIcon: {
        root: {
          fontSize: "24px!important",
        },
      },
    },
    nestedListItemText: {
      color: themes.palette.navbar.text,
      marginTop: 0,
      marginBottom: 0,
      "& span": {
        fontSize: "14px",
        fontWeight: 400,
      },
      MuiSvgIcon: {
        root: {
          fontSize: "22px!important",
        },
      },
    },
    delete: {},
    linkItem: {
      color: themes.palette.navbar.text,
      textDecoration: "none",
      "& .nav-icon-manage-profile": {
        filter: "brightness(0)",
      },
    },
    sectionHeader: {
      padding: "16px 16px 8px 16px",
      fontSize: "12px",
      fontWeight: 400,
      color: themes.palette.navbar.sectionHeader,
      letterSpacing: "0.5px",
      textTransform: "uppercase",
    },
    activeListItem: {
      backgroundColor: "#FFFFFF !important",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "8px 10px 8px 20px",
      minHeight: "60px",
      border: `1px solid ${themes.palette.primary.main}`,
      borderLeft: `3.5px solid ${themes.palette.primary.main}`,
      borderRadius: "16px",
      margin: "4px 8px",
      "& .MuiListItemIcon-root": {
        color: themes.palette.primary.main,
        minWidth: "34px",
      },
      "& .MuiListItemIcon-root img": {
        filter: "invert(57%) sepia(91%) saturate(424%) hue-rotate(358deg) brightness(94%) contrast(86%) !important",
      },
      "& .MuiListItemText-primary": {
        color: `${themes.palette.primary.main} !important`,
        fontStyle: "normal",
        fontWeight: "700 !important" as any,
        fontSize: "14px !important",
        lineHeight: "150% !important",
      },
    },
    activeParentListItem: {
      backgroundColor: "#FFFFFF !important",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "14px 16px 14px 20px",
      minHeight: "64px",
      borderWidth: "1px 0px 1px 3px",
      borderStyle: "solid",
      borderColor: themes.palette.primary.main,
      borderRadius: "7px",
      margin: "4px 8px",
      "& .MuiListItemIcon-root": {
        color: themes.palette.primary.main,
        minWidth: "34px",
      },
      "& .MuiListItemIcon-root img": {
        filter: "invert(57%) sepia(91%) saturate(424%) hue-rotate(358deg) brightness(94%) contrast(86%)",
      },
      "& .MuiListItemText-primary": {
        color: `${themes.palette.primary.main} !important`,
        fontStyle: "normal",
        fontWeight: "700 !important" as any,
        fontSize: "14px !important",
        lineHeight: "150% !important",
      },
    },
    nestedActiveListItem: {
      backgroundColor: "#FFFFFF !important",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      minHeight: "60px",
      paddingTop: "12px",
      paddingBottom: "12px",
      borderWidth: "1px 0px 1px 3px",
      borderStyle: "solid",
      borderColor: themes.palette.primary.main,
      borderRadius: "7px",
      margin: "4px 8px 4px 24px",
      paddingLeft: "8px",
      "& .MuiListItemIcon-root": {
        color: themes.palette.primary.main,
        minWidth: "34px",
      },
      "& .MuiListItemIcon-root img": {
        filter: "invert(57%) sepia(91%) saturate(424%) hue-rotate(358deg) brightness(94%) contrast(86%)",
      },
      "& .MuiListItemText-primary": {
        color: themes.palette.primary.main,
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "14px",
        lineHeight: "150%",
      },
    },
    logoSeparator: {
      borderBottom: `1px solid ${themes.palette.navbar.borderColor}`,
      marginLeft: "16px",
      marginRight: "16px",
      marginTop: "10px",
      marginBottom: "10px",
    },
    copyrightFooter: {
      textAlign: "center",
      fontSize: "10px",
      color: themes.palette.navbar.copyrightText,
      padding: "12px 16px",
      borderTop: `1px solid ${themes.palette.navbar.borderColor}`,
    },
    images: {
      overflow: "hidden",
      margin: "auto",
    },
    image: {
      width: "160px",
      height: "160px",
      borderRadius: "100%",
    },
    avatarImages: {
      borderRadius: "200px",
      margin: "auto",
      fontSize: "30px",
      backgroundColor: "#67b917",

      [theme.breakpoints.down("sm")]: {
        width: "85px",
        height: "85px",
      },
      [theme.breakpoints.up("sm")]: {
        width: "140px",
        height: "140px",
      },
    },
    toolbarItems: {
      zIndex: 10,
      display: "flex",
      width: "100%",
      position: "fixed",
      top: 0,
      backgroundColor: "white",
      [theme.breakpoints.up("lg")]: {
        display: "none",
      },
    },
    mobileSpacing: {
      height: "55px",
      [theme.breakpoints.up("lg")]: {
        display: "none",
      },
    },
  })
);

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  windows?: () => Window;
}

const NestedNavBarButton = ({
  route,
  iconName,
  title,
  useIconAsNavBarButtonTitle,
  nestedRoutes,
  aShopLocalCampaignIsActive,
  aRewardCampaignIsActive,
  setMobileOpen,
  isSandbox,
  iconObject,
  getIcon,
  isNew,
  badgeType,
}: any) => {
  const classes = useStyles();
  const enumStrings = useEnumStrings();
  const [open, setOpen] = React.useState(false);
  const [comingSoonOpen, setComingSoonOpen] = React.useState(false);
  const [comingSoonIsPerkPartners, setComingSoonIsPerkPartners] = React.useState(false);
  const { pathname: currentPathname } = useLocation();

  const isAnyNestedRouteActive = nestedRoutes?.some((nestedRoute: any) =>
    currentPathname === nestedRoute.route ||
    nestedRoute.nestedRoutes?.some((child: any) =>
      currentPathname === child.route
    )
  );

  // Auto-expand if a child is active
  React.useEffect(() => {
    if (isAnyNestedRouteActive) {
      setOpen(true);
    }
  }, [isAnyNestedRouteActive]);

  return (
    <div>
      <ListItem
        button
        onClick={() => setOpen(!open)}
        className={isAnyNestedRouteActive && !useIconAsNavBarButtonTitle ? classes.activeParentListItem : ""}
        style={{ marginTop: 4, marginBottom: 4 }}
      >
        {(iconName || useIconAsNavBarButtonTitle) && (
          <ListItemIcon>
            {useIconAsNavBarButtonTitle ? (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 4 }}>
                {getIcon ? getIcon(iconName, isAnyNestedRouteActive) : iconObject[iconName]}
                {badgeType && badgeType !== "new" && (
                  <NewBadge badgeType={badgeType} style={{ marginLeft: 0 }} />
                )}
              </div>
            ) : (
              getIcon ? getIcon(iconName, isAnyNestedRouteActive) : iconObject[iconName]
            )}
          </ListItemIcon>
        )}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            flex: 1,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              flex: 1,
            }}
          >
            {!useIconAsNavBarButtonTitle && (
              <ListItemText
                className={classes.listItemText}
                primary={title}
              />
            )}
            <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "8px", marginTop: 2, marginBottom: 6 }}>
            {badgeType && badgeType !== "new" && !useIconAsNavBarButtonTitle &&
              !(aShopLocalCampaignIsActive && route === RedirectUri.chamberShopLocal) &&
              !(aRewardCampaignIsActive && route === RedirectUri.chamberReward) && (
              <NewBadge
                badgeType={badgeType}
                style={{ marginLeft: 0 }}
              />
            )}
            {aShopLocalCampaignIsActive &&
              route === RedirectUri.chamberShopLocal && (
                <Chip
                  label={enumStrings.common.activated || "Activated"}
                  variant="outlined"
                  size="small"
                  style={{
                    color: "#4CAF50",
                    backgroundColor: "#FFFFFF",
                    borderColor: "#4CAF50",
                    borderWidth: "1.5px",
                    fontSize: "13px",
                    fontWeight: 700,
                    height: "28px",
                    padding: "0 4px",
                  }}
                />
              )}
            {aRewardCampaignIsActive && route === RedirectUri.chamberReward && (
              <Chip
                label={enumStrings.common.activeStatus || "Active"}
                variant="outlined"
                size="small"
                style={{
                  color: "#4CAF50",
                  backgroundColor: "#FFFFFF",
                  borderColor: "#4CAF50",
                  borderWidth: "1.5px",
                  fontSize: "13px",
                  fontWeight: 700,
                  height: "28px",
                  padding: "0 4px",
                }}
              />
            )}
          </div>
          </div>
          <div
            style={{
              color: isAnyNestedRouteActive && !useIconAsNavBarButtonTitle ? themes.palette.primary.main : themes.palette.navbar.text,
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginLeft: "auto",
            }}
          >
            {(isNew || badgeType === "new") && <NewBadge badgeType="new" />}
            {open ? (
              <ArrowUp style={{ fontSize: 24 }} />
            ) : (
              <ArrowDown style={{ fontSize: 24 }} />
            )}
          </div>
        </div>
      </ListItem>
      {open &&
        nestedRoutes.map((nestedRoute: any, index: number) => {
          if (
            aShopLocalCampaignIsActive &&
            nestedRoute.route === RedirectUri.createShopLocal
          ) {
            return null;
          }

          if (
            !aShopLocalCampaignIsActive &&
            nestedRoute.route === RedirectUri.activeChamberShopLocal
          ) {
            return null;
          }

          if (
            aRewardCampaignIsActive &&
            nestedRoute.route === RedirectUri.createReward
          ) {
            return null;
          }

          if (
            !aRewardCampaignIsActive &&
            nestedRoute.route === RedirectUri.activeChamberReward
          ) {
            return null;
          }

          // handle onlyShowOnSandbox
          if (nestedRoute.onlyShowOnSandbox && !isSandbox) {
            return null;
          }

          // Check if this nested route has its own nested routes (multi-level nesting)
          if (nestedRoute.nestedRoutes && nestedRoute.nestedRoutes.length > 0) {
            return (
              <div key={index} style={{ paddingLeft: 32 }}>
                <NestedNavBarButton
                  route={nestedRoute.route}
                  iconName={nestedRoute.iconName}
                  title={nestedRoute.title}
                  useIconAsNavBarButtonTitle={false}
                  nestedRoutes={nestedRoute.nestedRoutes}
                  aShopLocalCampaignIsActive={aShopLocalCampaignIsActive}
                  aRewardCampaignIsActive={aRewardCampaignIsActive}
                  setMobileOpen={setMobileOpen}
                  isSandbox={isSandbox}
                  iconObject={iconObject}
                  getIcon={getIcon}
                  isNew={nestedRoute.isNew}
                  badgeType={nestedRoute.badgeType}
                />
              </div>
            );
          }

          const isNestedRouteActive = currentPathname === nestedRoute.route;

          return (
            <Link
              className={classes.linkItem}
              onClick={(e) => {
                if (nestedRoute.showComingSoonDialog) {
                  e.preventDefault();
                  setComingSoonIsPerkPartners(
                    typeof nestedRoute.route === "string" &&
                    nestedRoute.route.startsWith("/perkpartners/portal")
                  );
                  setComingSoonOpen(true);
                  return;
                }

                setMobileOpen(false);

                // only refresh if trying to navigate to route again... user may want to see new content
                if (
                  nestedRoute.refreshOnClick &&
                  (window.location.pathname || "").trim().toLowerCase() ===
                  nestedRoute.route
                ) {
                  window.location.href = nestedRoute.route;
                }

                if (nestedRoute.overrideLink) {
                  handleDivClick({ url: nestedRoute.overrideLink });
                  return;
                }
              }}
              to={nestedRoute.showComingSoonDialog ? "#" : (nestedRoute.overrideLink ? undefined : nestedRoute.route)}
              key={index}
            >
              <ListItem
                button
                key={index}
                style={{ paddingLeft: 48, marginTop: 4, marginBottom: 4 }}
                className={isNestedRouteActive ? classes.nestedActiveListItem : ""}
              >
                {nestedRoute.iconName && <ListItemIcon>{getIcon ? getIcon(nestedRoute.iconName, isNestedRouteActive) : iconObject[nestedRoute.iconName]}</ListItemIcon>}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", flex: 1 }}>
                    <ListItemText
                      className={classes.nestedListItemText}
                      primary={nestedRoute.title}
                    />
                    {nestedRoute.badgeType && nestedRoute.badgeType !== "new" && (
                      <NewBadge
                        badgeType={nestedRoute.badgeType}
                        style={{ marginLeft: 0, marginTop: 2 }}
                      />
                    )}
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "auto" }}>
                    {(nestedRoute.isNew || nestedRoute.badgeType === "new") && <NewBadge badgeType="new" />}
                    {aShopLocalCampaignIsActive &&
                      nestedRoute.route ===
                      RedirectUri.activeChamberShopLocal && (
                        <Chip
                          label={enumStrings.common.activated || "Activated"}
                          variant="outlined"
                          size="small"
                          style={{
                            color: "#4CAF50",
                            backgroundColor: "#FFFFFF",
                            borderColor: "#4CAF50",
                            borderWidth: "1.5px",
                            fontSize: "13px",
                            fontWeight: 700,
                            height: "28px",
                            padding: "0 4px",
                          }}
                        />
                      )}
                    {aRewardCampaignIsActive &&
                      nestedRoute.route === RedirectUri.activeChamberReward && (
                        <Chip
                          label={enumStrings.common.activated || "Activated"}
                          variant="outlined"
                          size="small"
                          style={{
                            color: "#4CAF50",
                            backgroundColor: "#FFFFFF",
                            borderColor: "#4CAF50",
                            borderWidth: "1.5px",
                            fontSize: "13px",
                            fontWeight: 700,
                            height: "28px",
                            padding: "0 4px",
                          }}
                        />
                      )}
                  </div>
                </div>
              </ListItem>
            </Link>
          );
        })}
      <ComingSoonDialog
        open={comingSoonOpen}
        onClose={() => setComingSoonOpen(false)}
        useInfoIcon={comingSoonIsPerkPartners}
        maxWidth={comingSoonIsPerkPartners ? "560px" : undefined}
        title={
          comingSoonIsPerkPartners
            ? enumStrings.navText.perkPartnersPortalComingSoonTitle
            : undefined
        }
        subtitle={
          comingSoonIsPerkPartners
            ? enumStrings.navText.perkPartnersPortalComingSoonSubtitle
            : undefined
        }
        description={
          comingSoonIsPerkPartners
            ? enumStrings.navText.perkPartnersPortalComingSoonDescription
            : undefined
        }
      />
    </div>
  );
};

const handleDivClick = ({ url }: { url: string }) => {
  window.open(getExternalLinkUrl(url), "_blank");
};

export default function ResponsiveDrawer(props: Props) {
  // const enumStrings = useEnumStrings();
  const { windows } = props;
  const classes = useStyles();
  const enumStrings = useEnumStrings();

  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const {
    state: { userType },
  } = useContext(UserTypeContext);
  const chamberInfo = useGetChamberFromUserIdInAuth();
  const chamberMemberInfo = useGetChamberMemberFromUserIdInAuth();
  const { access: memberAccess, user: memberUser } = useMemberDashboardAccess();
  const { pathname: currentPathname } = useLocation();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const iconObject: any = {
    Description: <DescriptionOutlinedIcon style={{ fontSize: 24 }} />,
    CustomStatsIcon: (
      <img
        alt="ViewStatsIcon"
        style={{
          maxWidth: "24px",
          objectFit: "contain",
        }}
      />
    ),
    CustomManageChamberProfile: (
      <img
        alt="ManageYourChamberIcon"
        style={{
          maxWidth: "24px",
          objectFit: "contain",
        }}
      />
    ),
    CustomManageCompanyProfile: (
      <img
        alt="ManageCompanyProfileIcon"
        src={ManageCompanyProfileIcon}
        className="nav-icon-manage-profile"
        style={{
          maxWidth: "24px",
          objectFit: "contain",
        }}
      />
    ),
    CustomManageCompanyPerks: (
      <img
        alt="ManageCompanyPerksMemberIcon"
        src={ManageCompanyPerksMemberIcon}
        style={{
          maxWidth: "24px",
          objectFit: "contain",
        }}
      />
    ),
    CustomManageMembersPerks: <ListAltOutlinedIcon style={{ fontSize: 24 }} />,
    CustomViewMemberPerks: <CardGiftcardOutlinedIcon style={{ fontSize: 24 }} />,
    CustomAddIcon: (
      <img
        alt="MemberCreatePerksIcon"
        src={MemberCreatePerksIcon}
        style={{
          maxWidth: "24px",
          objectFit: "contain",
        }}
      />
    ),
    CustomSupport: <HelpOutlineIcon style={{ fontSize: 24 }} />,
    UserGuideAndSupportIcon: <DescriptionOutlinedIcon style={{ fontSize: 24 }} />,
    SendMemberCredentials: (
      <img
        alt="SendMemberCredentials"
        style={{
          maxWidth: "24px",
          objectFit: "contain",
        }}
      />
    ),
    ShopLocalIcon: (
      <img
        alt="ShopLocalNewIcon"
        style={{
          maxWidth: "24px",
          objectFit: "contain",
        }}
      />
    ),
    RewardIcon: (
      <img
        alt="RewardsNewIcon"
        style={{
          maxWidth: "24px",
          objectFit: "contain",
        }}
      />
    ),
    PerkLinkIcon: (
      <img
        alt="PerkLinksNewIcon"
        style={{
          maxWidth: "24px",
          objectFit: "contain",
        }}
      />
    ),
    PerkPartnersPortalIcon: (
      <img
        alt="PerkPartnersPortalIcon"
        style={{
          maxWidth: "24px",
          objectFit: "contain",
        }}
      />
    ),
    PeopleOutlinedIcon: (
      <img
        alt="MembersIcon"
        style={{
          maxWidth: "24px",
          objectFit: "contain",
        }}
      />
    ),
    GroupOutlinedIcon: (
      <img
        alt="FeaturedMemberIcon"
        style={{
          maxWidth: "24px",
          objectFit: "contain",
        }}
      />
    ),
    PersonAddOutlinedIcon: <PersonAddOutlinedIcon style={{ fontSize: 24 }} />,
    CardGiftcardOutlinedIcon: (
      <img
        alt="PerksIcon"
        style={{
          maxWidth: "24px",
          objectFit: "contain",
        }}
      />
    ),
    AddCircleOutlineIcon: <AddCircleOutlineIcon style={{ fontSize: 24 }} />,
    ListAltOutlinedIcon: (
      <img
        alt="CategoryAdvertIcon"
        style={{
          maxWidth: "24px",
          objectFit: "contain",
        }}
      />
    ),
    ContactMailOutlinedIcon: (
      <img
        alt="CredentialsIcon"
        style={{
          maxWidth: "24px",
          objectFit: "contain",
        }}
      />
    ),
    CPAMarketingToolkit: (
      <img
        alt="CPAMarketingToolkitLogo"
        src={CPAMarketingToolkitLogo}
        style={{
          maxWidth: "29px",
          objectFit: "contain",
          margin: "7px 15px 7px 10px",
        }}
      />
    ),
    HandWithPersonIcon: (
      <img
        alt="HandWithPersonIconLogo"
        src={HandWithPersonIconLogo}
        style={{
          maxWidth: "29px",
          objectFit: "contain",
          margin: "7px 15px 7px 10px",
        }}
      />
    ),
    CustomChamberEngageIcon: (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "12px 0px 7px 0px",
        }}
      >
        <img
          alt="CustomChamberEngageIcon"
          src={CustomChamberEngageIcon}
          style={{
            maxWidth: "212px",
            objectFit: "contain",
            clipPath: "inset(0 0 8px 0)",
            WebkitClipPath: "inset(0 0 8px 0)",
          }}
        />
        <span style={{ fontSize: 13, color: themes.palette.navbar.sectionHeader, marginTop: -10 }}>
          {enumStrings.NonDuesRevenuePlatform}
        </span>
      </div>
    ),
    CustomChamberMarketerLogo: (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "12px 0px 7px 0px",
        }}
      >
        <img
          alt="CustomChamberMarketerLogo"
          src={CustomChamberMarketerLogo}
          style={{
            maxWidth: "212px",
            objectFit: "contain",
            clipPath: "inset(0 0 8px 0)",
            WebkitClipPath: "inset(0 0 8px 0)",
          }}
        />
        <span style={{ fontSize: 13, color: themes.palette.navbar.sectionHeader, marginTop: -10 }}>
          {enumStrings.navLearningMarketing}
        </span>
      </div>
    ),
    CustomChamberMarketerFreshdeskLogo: (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "12px 0px 7px 0px",
        }}
      >
        <img
          alt="CustomChamberMarketerLogo"
          src={CustomChamberMarketerLogo}
          style={{
            maxWidth: "212px",
            objectFit: "contain",
            clipPath: "inset(0 0 8px 0)",
            WebkitClipPath: "inset(0 0 8px 0)",
          }}
        />
        <span style={{ fontSize: 13, color: themes.palette.navbar.sectionHeader, marginTop: -10 }}>
          {enumStrings.navLearningMarketing}
        </span>
      </div>
    ),
    CustomManualLaunchGuideLogo: (
      <img
        alt="CustomManualLaunchGuideLogo"
        src={CustomManualLaunchGuideLogo}
        style={{
          maxWidth: "202px",
          objectFit: "contain",
          margin: "6px 0px 9px 12px",
        }}
      />
    ),
    ChamberEngageManageCategoryAdvertisingBannersChamberMemberIcon: (
      <img
        alt="ManageAdvertMemberIcon"
        src={ManageAdvertMemberIcon}
        style={{
          maxWidth: "24px",
          objectFit: "contain",
        }}
      />
    ),
    ManageFeaturedMemberBannersIcon: (
      <img
        alt="ManageFeaturedMemberBannersIcon"
        src={ManageFeaturedMemberBannersIcon}
        style={{
          maxWidth: "24px",
          objectFit: "contain",
        }}
      />
    ),
  };

  // Function to get the appropriate icon based on the icon name and active state
  const getIcon = useCallback((iconName: string, isActive: boolean) => {
    const iconStyle = {
      maxWidth: "24px",
      objectFit: "contain" as const,
    };

    const activeFilter = "brightness(0) saturate(100%) invert(67%) sepia(67%) saturate(481%) hue-rotate(5deg) brightness(95%) contrast(87%)";

    // View Stats icon
    if (iconName === "CustomStatsIcon") {
      return (
        <img
          alt="ViewStatsIcon"
          src={ViewStatsNavIcon}
          style={{
            ...iconStyle,
            filter: isActive ? activeFilter : "none",
          }}
        />
      );
    }
    if (iconName === "SendMemberCredentials") {
      return (
        <img
          alt="SendMemberCredentials"
          src={CredentialsIcon}
          style={{
            ...iconStyle,
            filter: isActive ? activeFilter : "none",
          }}
        />
      );
    }
    if (iconName === "MembersIcon") {
      return (
        <img
          alt="MembersIcon"
          src={MembersNavIcon}
          style={{
            ...iconStyle,
            filter: isActive ? activeFilter : "none",
          }}
        />
      );
    }

    // Manage Your Chamber icon
    if (iconName === "CustomManageChamberProfile") {
      return (
        <img
          alt="ManageYourChamberIcon"
          src={ManageYourChamberNavIcon}
          style={{
            ...iconStyle,
            filter: isActive ? activeFilter : "none",
          }}
        />
      );
    }

    // Members parent icon (PeopleOutlinedIcon)
    if (iconName === "PeopleOutlinedIcon") {
      return (
        <img
          alt="MembersIcon"
          src={MembersNavIcon}
          style={{
            ...iconStyle,
            filter: isActive ? activeFilter : "none",
          }}
        />
      );
    }

    // Create Members icon (PersonAddOutlinedIcon)
    if (iconName === "PersonAddOutlinedIcon") {
      return (
        <img
          alt="CreateMembersIcon"
          src={CreateMembersBlackIcon}
          style={{
            ...iconStyle,
            filter: isActive ? activeFilter : "none",
          }}
        />
      );
    }

    // Featured Member Status icon
    if (iconName === "FeaturedMemberStatusIcon") {
      return (
        <img
          alt="FeaturedMemberStatusIcon"
          src={FeaturedMemberNavIcon}
          style={{
            ...iconStyle,
            filter: isActive ? "none" : "brightness(0)",
          }}
        />
      );
    }

    // Manage Members icon (GroupOutlinedIcon)
    if (iconName === "GroupOutlinedIcon") {
      return (
        <img
          alt="ManageMembersIcon"
          src={ManageMembersNavIcon}
          style={{
            ...iconStyle,
            filter: isActive ? activeFilter : "none",
          }}
        />
      );
    }

    // Perks parent icon
    if (iconName === "CardGiftcardOutlinedIcon") {
      return (
        <img
          alt="PerksIcon"
          src={PerksNavIcon}
          style={{
            ...iconStyle,
            filter: isActive ? "none" : "brightness(0)",
          }}
        />
      );
    }

    // Create Member Perks icons (AddCircleOutlineIcon)
    if (iconName === "AddCircleOutlineIcon") {
      return (
        <img
          alt="CreateMemberPerksIcon"
          src={CreateMemberPerksNavIcon}
          style={{
            ...iconStyle,
            filter: isActive ? "none" : "brightness(0)",
          }}
        />
      );
    }

    // Manage Member Perks icons (ListAltOutlinedIcon)
    if (iconName === "ListAltOutlinedIcon") {
      return (
        <img
          alt="ManageMemberPerksIcon"
          src={ManageMemberPerksNavIcon}
          style={{
            ...iconStyle,
            filter: isActive ? activeFilter : "none",
          }}
        />
      );
    }

    // Category Advertising Banners icon
    if (iconName === "CategoryAdvertIcon") {
      return (
        <img
          alt="CategoryAdvertIcon"
          src={CategoryAdvertNavIcon}
          style={{
            ...iconStyle,
            filter: isActive ? activeFilter : "brightness(0)",
          }}
        />
      );
    }

    // Shop Local parent icon
    if (iconName === "ShopLocalIcon") {
      return (
        <img
          alt="ShopLocalIcon"
          src={ShopLocalNavIcon}
          style={{
            ...iconStyle,
            filter: isActive ? activeFilter : "none",
          }}
        />
      );
    }

    // Rewards parent icon
    if (iconName === "RewardIcon") {
      return (
        <img
          alt="RewardsIcon"
          src={RewardsNavIcon}
          style={{
            ...iconStyle,
            filter: isActive ? activeFilter : "none",
          }}
        />
      );
    }

    // Perk Link icon
    if (iconName === "PerkLinkIcon") {
      return (
        <img
          alt="PerkLinkIcon"
          src={PerkLinksNavIcon}
          style={{
            ...iconStyle,
            filter: isActive ? activeFilter : "none",
          }}
        />
      );
    }

    // Perk Partners Portal icon
    if (iconName === "PerkPartnersPortalIcon") {
      return (
        <img
          alt="PerkPartnersPortalIcon"
          src={isActive ? PerkPartnersPortalOrangeNavIcon : PerkPartnersPortalNavIcon}
          style={iconStyle}
        />
      );
    }

    // Fallback to original iconObject
    return iconObject[iconName];
  }, [iconObject]);

  const handleDrawerToggle = useCallback(() => {
    setMobileOpen(!mobileOpen);
  }, [mobileOpen]);

  const handleLogout = useHandleLogout();

  const { data: activeShopLocalCampaignForChamberMemberData } =
    useGetActiveShopLocalCampaignForChamberMemberQuery({
      skip: userType !== UserType.ChamberMemberAdmin || !memberAccess?.canManageProfile,
      fetchPolicy: "network-only",
    });

  const { data: allShopLocalCampaignsForChamber } =
    useGetAllShopLocalCampaignsForChamberQuery({
      fetchPolicy: "network-only",
      skip: userType !== UserType.ChamberAdmin,
    });

  const { data: subscriptionPlanTypeData } = useGetSubscriptionPlanTypeQuery({
    variables: { chamberId: chamberInfo?.id || "" },
    skip: !chamberInfo?.id || !(userType === UserType.ChamberAdmin),
  });

  const aShopLocalCampaignIsActive = useMemo(() => {
    if (userType === UserType.ChamberMemberAdmin) {
      if (
        activeShopLocalCampaignForChamberMemberData?.getActiveShopLocalCampaignForChamber
      ) {
        return {
          isUpcoming: !(
            Date.now() >
            (activeShopLocalCampaignForChamberMemberData
              ?.getActiveShopLocalCampaignForChamber?.startDateUtcMilli || 0)
          ),
        };
      }
    }

    if (userType === UserType.ChamberAdmin) {
      for (const campaign of allShopLocalCampaignsForChamber?.getAllShopLocalCampaignsForChamber ||
        []) {
        if (campaign?.status === ShopLocalCampaignStatusEnum.Active) {
          return {
            isUpcoming: !(Date.now() > campaign?.startDateUtcMilli),
          };
        }
      }
    }

    return null;
  }, [
    activeShopLocalCampaignForChamberMemberData?.getActiveShopLocalCampaignForChamber,
    allShopLocalCampaignsForChamber?.getAllShopLocalCampaignsForChamber,
    userType,
  ]);

  const { data: allRewardCampaignsForChamber } =
    useGetAllRewardCampaignsForChamberQuery({
      fetchPolicy: "network-only",
      skip: userType !== UserType.ChamberAdmin,
    });

  const aRewardCampaignIsActive = useMemo(() => {
    if (userType === UserType.ChamberAdmin) {
      for (const campaign of allRewardCampaignsForChamber?.getAllRewardCampaignsForChamber ||
        []) {
        const { campaignIsActive, campaignIsUpcoming } =
          checkIfRewardCampaignIsActive({
            campaign,
          });

        if (campaignIsActive || campaignIsUpcoming) {
          return {
            isUpcoming: campaignIsUpcoming,
          };
        }
      }
    }

    return null;
  }, [allRewardCampaignsForChamber?.getAllRewardCampaignsForChamber, userType]);

  const isMemberProfileAndPerksBannersActiveForChamberMember =
    useIsMemberProfileAndPerksBannersActiveForChamberMember({
      activeMemberProfileAndPerksBannersSettings:
        chamberMemberInfo?.activeMemberProfileAndPerksBannersSettings,
    });

  const isCategoryAdvertisingBannersActiveForChamberMember =
    useCheckIfCategoryAdvertisingBannersActiveForChamberMember({
      // The API allows this read only for logins with banner access (HR and
      // Employee Adoption contacts have none); a refused read opens /error.
      userType: memberAccess?.canManageBanners ? userType : undefined,
    });

  const getChamberEngageNavBarPillInfo = useCallback(
    ({
      route,
    }: {
      route: RedirectUri;
    }): {
      pillText: string;
      popupText: string;
      pillBackgroundColor: string;
      pillBorderColor: string;
      pillTextColor: string;
      pillFontWeight: number;
    } => {
      if (
        route !==
        RedirectUri.chamberEngageManageCategoryAdvertisingBannersChamberMember
      ) {
        if (isMemberProfileAndPerksBannersActiveForChamberMember) {
          return {
            pillText:
              enumStrings.chamberEngage.navBar.featuredMember.active.pillText,
            popupText: `${enumStrings.Nav.FeaturedMemberActive} ${chamberInfo?.name} ${enumStrings.Nav.ToLearnMore}`,
            pillBackgroundColor: "transparent",
            pillBorderColor: "transparent",
            pillTextColor: themes.palette.success.main,
            pillFontWeight: 600,
          };
        }

        return {
          pillText:
            enumStrings.chamberEngage.navBar.featuredMember.inactive.pillText,
          popupText: `${enumStrings.Nav.FeaturedMemberInactive} ${chamberInfo?.name} ${enumStrings.Nav.ToLearnMore}`,
          pillBackgroundColor: "transparent",
          pillBorderColor: "transparent",
          pillTextColor: "#727272",
          pillFontWeight: 600,
        };
      }

      if (
        route ===
        RedirectUri.chamberEngageManageCategoryAdvertisingBannersChamberMember
      ) {
        if (isCategoryAdvertisingBannersActiveForChamberMember) {
          return {
            pillText:
              enumStrings.chamberEngage.navBar.categoryBanners.active.pillText,
            popupText:
              enumStrings.chamberEngage.navBar.categoryAdvertising.popupInfo.active(
                {
                  chamberName: chamberInfo?.name || "",
                }
              ),
            pillBackgroundColor: "transparent",
            pillBorderColor: "transparent",
            pillTextColor: themes.palette.success.main,
            pillFontWeight: 600,
          };
        }

        return {
          pillText:
            enumStrings.chamberEngage.navBar.categoryBanners.inactive.pillText,
          popupText:
            enumStrings.chamberEngage.navBar.categoryAdvertising.popupInfo.inactive(
              {
                chamberName: chamberInfo?.name || "",
              }
            ),
          pillBackgroundColor: "transparent",
          pillBorderColor: "transparent",
          pillTextColor: "#000000",
          pillFontWeight: 400,
        };
      }

      return {
        pillText: "",
        popupText: "",
        pillBackgroundColor: "",
        pillBorderColor: "",
        pillTextColor: "",
        pillFontWeight: 600,
      };
    },
    [
      isMemberProfileAndPerksBannersActiveForChamberMember,
      enumStrings.chamberEngage.navBar.featuredMember.inactive.pillText,
      enumStrings.chamberEngage.navBar.featuredMember.active.pillText,
      enumStrings.chamberEngage.navBar.categoryBanners.inactive.pillText,
      enumStrings.chamberEngage.navBar.categoryBanners.active.pillText,
      enumStrings.chamberEngage.navBar.categoryAdvertising.popupInfo,
      enumStrings.Nav.FeaturedMemberInactive,
      enumStrings.Nav.ToLearnMore,
      enumStrings.Nav.FeaturedMemberActive,
      chamberInfo?.name,
      isCategoryAdvertisingBannersActiveForChamberMember,
    ]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const navToShow = useMemo(() => {
    if (!userType || userType.length === 0) {
      return [];
    }
    // @ts-ignore
    const routeObjs = Object.values(enumStrings.groups[userType as UserType]);
    return routeObjs.map(
      (
        {
          route,
          iconName,
          title,
          showInNavBar,
          sandboxTitle,
          sandBoxIconName,
          onlyShowOnSandbox,
          onlyHideOnSandbox,
          forceOpenInNewTab,
          nestedRoutes: nestedRoutesArr,
          useIconAsNavBarButtonTitle,
          onlyShowOnActiveChamberEngage,
          showEnhancedBannersPill,
          refreshOnClick,
          overrideLink,
          onlyActiveForSubscriptionPlanTypes,
          disabledForSubscriptionPopupText: disabledForSubscriptionPopupTextRaw,
          isNew,
          badgeType,
        }: any,
        index
      ) => {
        if (userType === UserType.ChamberMemberAdmin && !canUseMemberRoute(route, memberAccess)) return null;
        let nestedRoutes = nestedRoutesArr;

        if (onlyShowOnSandbox && !chamberInfo?.isSandbox) {
          return null;
        }

        if (onlyHideOnSandbox && chamberInfo?.isSandbox) {
          return null;
        }

        if (
          onlyShowOnActiveChamberEngage &&
          !chamberInfo?.chamberEngageSettings.isActive
        ) {
          return null;
        }

        let disableForInvalidSubscriptionPlan = false;
        if (
          onlyActiveForSubscriptionPlanTypes &&
          subscriptionPlanTypeData?.getChamber?.subscriptionPlanType
        ) {
          if (
            !onlyActiveForSubscriptionPlanTypes.includes(
              subscriptionPlanTypeData?.getChamber?.subscriptionPlanType
            )
          ) {
            disableForInvalidSubscriptionPlan = true;
            nestedRoutes = null;
          }
        }

        let disabledForSubscriptionPopupText = "";
        if (
          disableForInvalidSubscriptionPlan &&
          disabledForSubscriptionPopupTextRaw
        ) {
          if (route === RedirectUri.chamberReward) {
            disabledForSubscriptionPopupText =
              disabledForSubscriptionPopupTextRaw.replace(
                "{chamberName}",
                chamberInfo?.name || ""
              ) + ` ${defaultEnumStrings.subscriptionsContactEmail}.`;
          } else {
            disabledForSubscriptionPopupText =
              disabledForSubscriptionPopupTextRaw;
          }
        }

        // Hide member dashboard Shop Local page when contest isn't active
        if (
          route === RedirectUri.chamberMemberShopLocal &&
          (!aShopLocalCampaignIsActive || aShopLocalCampaignIsActive.isUpcoming)
        ) {
          return null;
        }

        return (
          <React.Fragment key={index}>
            {showInNavBar ? (
              <>
                {nestedRoutes ? (
                  <NestedNavBarButton
                    route={route}
                    iconName={iconName}
                    title={title}
                    useIconAsNavBarButtonTitle={useIconAsNavBarButtonTitle}
                    nestedRoutes={nestedRoutes}
                    setMobileOpen={setMobileOpen}
                    aShopLocalCampaignIsActive={aShopLocalCampaignIsActive}
                    aRewardCampaignIsActive={aRewardCampaignIsActive}
                    isSandbox={chamberInfo?.isSandbox}
                    iconObject={iconObject}
                    getIcon={getIcon}
                    isNew={isNew}
                    badgeType={badgeType}
                  />
                ) : (
                  <Link
                    className={classes.linkItem}
                    onClick={() => {
                      setMobileOpen(false);

                      if (overrideLink) {
                        handleDivClick({ url: overrideLink });
                        return;
                      }

                      if (forceOpenInNewTab) {
                        handleDivClick({ url: route });
                        return;
                      }

                      // only refresh if trying to navigate to route again... user may want to see new content
                      if (
                        refreshOnClick &&
                        (window.location.pathname || "")
                          .trim()
                          .toLowerCase() === route
                      ) {
                        window.location.href = route;
                      }
                    }}
                    to={
                      forceOpenInNewTab ||
                        overrideLink ||
                        disableForInvalidSubscriptionPlan
                        ? undefined
                        : route
                    }
                  >
                    <ListItem
                      button
                      key={index}
                      className={currentPathname === route || currentPathname === route + "/update" ? classes.activeListItem : ""}
                      style={{ marginTop: 4, marginBottom: 4 }}
                    >
                      <ListItemIcon>
                        {useIconAsNavBarButtonTitle ? (
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 4 }}>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", gap: 8 }}>
                              {getIcon(
                                chamberInfo?.isSandbox && sandBoxIconName
                                  ? sandBoxIconName
                                  : iconName,
                                currentPathname === route || currentPathname === route + "/update"
                              )}
                              {(isNew || badgeType === "new") && (
                                <NewBadge badgeType="new" style={{ marginLeft: 0, marginTop: 16 }} />
                              )}
                            </div>
                            {badgeType && badgeType !== "new" && (
                              <NewBadge badgeType={badgeType} style={{ marginLeft: 0 }} />
                            )}
                          </div>
                        ) : (
                          getIcon(
                            chamberInfo?.isSandbox && sandBoxIconName
                              ? sandBoxIconName
                              : iconName,
                            currentPathname === route || currentPathname === route + "/update"
                          )
                        )}
                      </ListItemIcon>
                      {!useIconAsNavBarButtonTitle && (
                        <div style={{ width: "100%" }}>
                          <div style={{ display: "flex", alignItems: "center", width: "100%", justifyContent: "space-between" }}>
                            <ListItemText
                              className={classes.listItemText}
                              primary={
                                chamberInfo?.isSandbox && sandboxTitle
                                  ? sandboxTitle
                                  : title
                              }
                            />
                            {(isNew || badgeType === "new") && <div style={{ marginLeft: "auto" }}><NewBadge badgeType="new" /></div>}
                          </div>
                          {badgeType && badgeType !== "new" && (
                            <NewBadge
                              badgeType={badgeType}
                              style={{ marginLeft: 0, marginTop: 2, alignSelf: "flex-start" }}
                            />
                          )}
                          {disableForInvalidSubscriptionPlan &&
                            disabledForSubscriptionPopupText && (
                              <Tooltip
                                arrow
                                title={
                                  <div
                                    style={{
                                      backgroundColor: "#707070",
                                    }}
                                  >
                                    <Typography
                                      style={{
                                        color: "white",
                                        fontSize: "12px",
                                        whiteSpace: "pre-wrap",
                                      }}
                                    >
                                      {disabledForSubscriptionPopupText}
                                    </Typography>
                                  </div>
                                }
                                placement="right"
                              >
                                <Chip
                                  label={"Inactive"}
                                  variant="outlined"
                                  size="small"
                                  style={{
                                    marginBottom: 11,
                                    marginTop: -4,
                                    backgroundColor: "#E3E4E6",
                                    borderColor: "#727272",
                                    color: "#727272",
                                  }}
                                />
                              </Tooltip>
                            )}
                          {aShopLocalCampaignIsActive &&
                            route === RedirectUri.chamberMemberShopLocal && (
                              <Chip
                                label={"Active"}
                                variant="outlined"
                                size="small"
                                style={{
                                  marginBottom: 11,
                                  marginTop: -4,
                                  color: "#34694F",
                                  backgroundColor: "#DCEEDC",
                                  borderColor: "#34694F",
                                }}
                              />
                            )}
                          {route === RedirectUri.memberInvoices && memberAccess?.canViewInvoices && memberUser && (
                            <MemberInvoiceNavSummary key={`${memberUser.id}:${memberUser.chamberId}:${memberUser.chamberMemberId}:${memberAccess.contactId}`} />
                          )}
                          {showEnhancedBannersPill && (
                            <Tooltip
                              arrow
                              title={
                                <div
                                  style={{
                                    backgroundColor: "#707070",
                                  }}
                                >
                                  <Typography
                                    style={{
                                      color: "white",
                                      fontSize: "12px",
                                      whiteSpace: "pre-wrap",
                                    }}
                                  >
                                    {
                                      getChamberEngageNavBarPillInfo({
                                        route,
                                      }).popupText
                                    }
                                  </Typography>
                                </div>
                              }
                              placement="right"
                            >
                              <span
                                style={{
                                  fontWeight: getChamberEngageNavBarPillInfo({
                                    route,
                                  }).pillFontWeight,
                                  fontSize: "11px",
                                  lineHeight: "140%",
                                  letterSpacing: "0.02em",
                                  textTransform: "uppercase",
                                  color: getChamberEngageNavBarPillInfo({
                                    route,
                                  }).pillTextColor,
                                  display: "block",
                                  marginTop: 0,
                                }}
                              >
                                {
                                  getChamberEngageNavBarPillInfo({
                                    route,
                                  }).pillText
                                }
                              </span>
                            </Tooltip>
                          )}
                        </div>
                      )}
                    </ListItem>
                  </Link>
                )}
              </>
            ) : null}
          </React.Fragment>
        );
      }
    );
  }, [
    memberAccess,
    memberUser,
    aRewardCampaignIsActive,
    aShopLocalCampaignIsActive,
    chamberInfo?.chamberEngageSettings.isActive,
    chamberInfo?.isSandbox,
    chamberInfo?.name,
    classes.activeListItem,
    classes.linkItem,
    classes.listItemText,
    currentPathname,
    enumStrings.groups,
    getIcon,
    getChamberEngageNavBarPillInfo,
    iconObject,
    subscriptionPlanTypeData?.getChamber?.subscriptionPlanType,
    userType,
  ]);

  const logoSource = useMemo(() => {
    if (
      userType === UserType.RootAdmin ||
      userType === UserType.PerkPartnerDiscountAdmin
    ) {
      return CPALogo;
    }

    if (userType === UserType.ChamberMemberAdmin) {
      return chamberMemberInfo?.logo;
    }

    return chamberInfo?.logo;
  }, [chamberInfo?.logo, chamberMemberInfo?.logo, userType]);

  const isChamber = useIsChamber();

  const getNavTitle = useCallback(() => {
    if (userType === UserType.RootAdmin) {
      return enumStrings.navText.rootAdminText;
    }
    if (userType === UserType.ChamberAdmin) {
      return isChamber
        ? enumStrings.navText.chamberAdminText
        : enumStrings.navText.boardAdminText;
    }
    if (userType === UserType.ChamberMemberAdmin) {
      return enumStrings.navText.chamberMemberAdminText;
    }
    if (userType === UserType.PerkPartnerDiscountAdmin) {
      return enumStrings.navText.perkPartnerAdminText;
    }

    return enumStrings.common.dashboard;
  }, [
    enumStrings.common.dashboard,
    enumStrings.navText.boardAdminText,
    enumStrings.navText.chamberAdminText,
    enumStrings.navText.chamberMemberAdminText,
    enumStrings.navText.perkPartnerAdminText,
    enumStrings.navText.rootAdminText,
    isChamber,
    userType,
  ]);

  // Wave C ACON-1: CMP member logins get the design (Accelerator) sidebar;
  // CPA-only members and staff keep this navigation.
  const cmpMemberSidebar =
    userType === UserType.ChamberMemberAdmin && memberAccess?.cmpEnabled ? (
      <CmpMemberSidebar
        access={memberAccess}
        chamberName={chamberInfo?.name}
        memberName={chamberMemberInfo?.name}
        memberLogo={chamberMemberInfo?.logo}
        featuredMember={!!chamberMemberInfo?.activeMemberProfileAndPerksBannersSettings?.activationInfo?.startDateUtcMilli}
        sponsorLogo={chamberInfo?.sponsorLogo}
        sponsorLogoLink={chamberInfo?.sponsorLogoLink}
        helpContactName={getSignedInContactName(chamberMemberInfo, memberUser?.email)}
        helpContactEmail={memberUser?.email}
        loginEmail={memberUser?.email}
        perksOffered={memberAccess?.perksOffered !== false}
        onLogout={handleLogout}
        onNavigate={() => setMobileOpen(false)}
      />
    ) : null;

  const drawer = cmpMemberSidebar || (
    <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
      {/* Sand Bay test mode on a CPA test plan (Not in design, Moeen approved Oct 16 2026). Renders only when the backend sets testMode.available. */}
      {userType === UserType.ChamberMemberAdmin && memberAccess?.testMode?.available === true ? (
        <div style={{ padding: "16px 16px 0" }}><CmpMemberTestMode testMode={memberAccess.testMode} /></div>
      ) : null}
      <div className={classes.toolbar}>
        <div
          style={{
            fontWeight: "bold",
            textAlign: "center",
            paddingTop: "20px",
          }}
        >
          {userType === UserType.ChamberMemberAdmin
            ? chamberMemberInfo?.name
            : userType !== UserType.RootAdmin && userType !== UserType.ChamberAdmin
            ? chamberInfo?.name
            : ""}
        </div>

        <div>
          <div className={classes.profileIcon}>
            {/* @ts-ignore */}
            <LogoImage
              dontLazyLoad
              maxWidth
              squared
              size="xl"
              logoSource={logoSource}
            />
          </div>
          {userType === UserType.ChamberMemberAdmin && chamberInfo?.name ? (
            <div className={classes.adminTitle}>
              {chamberInfo.name} {getNavTitle()}
            </div>
          ) : null}
          <div className={classes.logoSeparator} />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          flex: 1,
        }}
      >
        <div>
          <div className={classes.sectionHeader}>{enumStrings.common.menu}</div>
          <List style={{ paddingTop: 0 }}>{navToShow}</List>
        </div>

        <div>
          {userType !== UserType.RootAdmin &&
            userType !== UserType.PerkPartnerDiscountAdmin ? (
            <>
              <div className={classes.sectionHeader}>{enumStrings.common.sponsoredBy}</div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  borderRadius: "16px",
                  margin: "15px",
                  marginTop: "5px",
                  marginBottom: "10px",
                  boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.25)",
                  padding: "10px",
                  fontWeight: "bold",
                }}
              >
                <div
                  style={{
                    paddingRight: "15px",
                    paddingLeft: "15px",
                  }}
                >
                  {chamberInfo?.sponsorLogo ? (
                    <LogoImage
                      dontLazyLoad
                      onClick={
                        chamberInfo?.sponsorLogoLink &&
                          chamberInfo?.sponsorLogoLink.length > 0
                          ? () =>
                            handleDivClick({
                              url: chamberInfo?.sponsorLogoLink || "",
                            })
                          : undefined
                      }
                      maxWidth
                      squared
                      size="normal"
                      logoSource={chamberInfo?.sponsorLogo || ""}
                    />
                  ) : (
                    <div
                      style={{
                        color: themes.palette.navbar.sectionHeader,
                        fontSize: "20px",
                        height: 70,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {enumStrings.available}
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : null}

          <div className={classes.sectionHeader}>{enumStrings.common.general}</div>
          <List style={{ paddingTop: 0 }}>
            <Link
              to="/settings"
              style={{
                textDecoration: "none",
                color: "inherit",
              }}
            >
              <ListItem button>
                <ListItemIcon>
                  <img
                    alt="LanguageIcon"
                    src={LanguageIcon}
                    style={{
                      maxWidth: "24px",
                      objectFit: "contain",
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  className={classes.listItemText}
                  primary={enumStrings.sidebarText.settingTitle}
                />
              </ListItem>
            </Link>

            <ListItem
              button
              onClick={() =>
                handleDivClick({
                  url: "https://chamberperksapp.freshdesk.com/support/tickets/new",
                })
              }
            >
              <ListItemIcon>
                <img
                  alt="HelpIcon"
                  src={HelpIcon}
                  style={{
                    maxWidth: "24px",
                    objectFit: "contain",
                  }}
                />
              </ListItemIcon>
              <div>
                <ListItemText
                  className={classes.listItemText}
                  primary={enumStrings.sidebarText.needHelp}
                />
                <span
                  style={{
                    fontSize: "11px",
                    color: themes.palette.navbar.sectionHeader,
                    display: "block",
                    marginTop: "-4px",
                  }}
                >
                  {enumStrings.sidebarText.createTicketFromHere}
                </span>
              </div>
            </ListItem>

            <ListItem button onClick={handleLogout}>
              <ListItemIcon>
                <img
                  alt="LogoutIcon"
                  src={LogoutIcon}
                  style={{
                    maxWidth: "24px",
                    objectFit: "contain",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                className={classes.listItemText}
                primary={enumStrings.sidebarText.logoutTitle}
                style={{ color: "red" }}
              />
            </ListItem>
          </List>

          <div className={classes.copyrightFooter}>
            Copyright @ 2025,<br />
            Chamber Perks App™ Dashboard
          </div>
        </div>
      </div>
    </div>
  );

  const container =
    windows !== undefined ? () => windows().document.body : undefined;

  const cmpMemberDrawer = userType === UserType.ChamberMemberAdmin && !!memberAccess?.cmpEnabled;

  return (
    <div className={classes.rootItem}>
      <nav className={cmpMemberDrawer ? classes.cmpDrawer : classes.drawer} aria-label="mailbox folders">
        <CssBaseline />
        <Toolbar className={classes.toolbarItems}>
          <div
            style={{
              flex: 1,
            }}
          >
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              className={clsx(classes.menuButton, mobileOpen && classes.hide)}
              style={{
                backgroundColor: themes.palette.primary.main,
                width: "50px",
                height: "50px",
                color: "white",
              }}
            >
              <MenuIcon />
            </IconButton>
          </div>
          <div
            style={{
              textAlign: "center",
              color: themes.palette.primary.main,
              fontWeight: "bold",
              fontSize: "18px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              flex: 1,
            }}
          >
            {getNavTitle()}
          </div>
          <div style={{ flex: 1 }} />
        </Toolbar>
        <div className={classes.mobileSpacing} />
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: cmpMemberDrawer ? classes.cmpDrawerPaper : classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden mdDown implementation="css">
          <Drawer
            classes={{
              paper: cmpMemberDrawer ? classes.cmpDrawerPaperDocked : classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
    </div>
  );
}
